  <th scope="row"><div class="text-center"><img height="150px" src="http://162.213.250.33/ceratube/assets/images/product-img/{{item.product.details.VIG}}"/></div></th>
  <td class="titleProductCart"><h6>{{item.product.details.ITMDES1}}</h6></td>
  <td><p>{{item.product.details.ITMREF}}</p></td>
  <td><p>{{item.product.details.PRIXBRUT}} MAD</p></td>
  <td>
      <div class="col-sm-12 m-0 qteBlocCart text-center">
      <input type="number" id="quantity" (change)="changeQte($event.target.value,item)" name="quantity" min="1" max="100" value="{{item.item_quantity}}">
     </div>
  </td>
  <td><p>{{item.product.details.PRIXBRUT*item.item_quantity}}</p></td>
  <td><div class="text-center"><img src="assets/front/images/trash-o.png"/></div></td>
